import { render, staticRenderFns } from "./UnresolvedLabelsSummary.vue?vue&type=template&id=6782963c&scoped=true&"
import script from "./UnresolvedLabelsSummary.vue?vue&type=script&lang=js&"
export * from "./UnresolvedLabelsSummary.vue?vue&type=script&lang=js&"
import style0 from "./UnresolvedLabelsSummary.vue?vue&type=style&index=0&id=6782963c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6782963c",
  null
  
)

export default component.exports